import React, { useState } from 'react';

import { Button } from 'components/cosmos';
import { useTranslation } from 'configs/translationContext';

export default function PreviewCertificate({ openCertificate }) {
  const [isOpening, setIsOpening] = useState(false);
  const { t } = useTranslation();

  async function handleClick() {
    setIsOpening(true);
    try {
      await openCertificate();
      setIsOpening(false);
    } catch {
      setIsOpening(false);
    }
  }

  return (
    <Button
      className="_mr-4"
      variation="secondary"
      onClick={handleClick}
      loading={isOpening}
    >
      {t('config_manager.config_certicate.preview_certificate')}
    </Button>
  );
}
